export default __webpack_public_path__ + "static/media/3.fed1ef3e.jpeg";